import { store } from "../store";

export async function runQuery<Arg, Result>(
  initiate: any,
  arg: Arg,
  options?: Record<string, unknown>,
): Promise<Result> {
  const thunk = store.dispatch(initiate(arg, { subscribe: false, ...(options || {}) })) as any;
  try {
    return (await thunk.unwrap()) as Result;
  } finally {
    if (typeof thunk.unsubscribe === "function") {
      thunk.unsubscribe();
    }
  }
}

export async function runQueryNoArg<Result>(
  initiate: any,
): Promise<Result> {
  return runQuery<void, Result>(initiate, undefined);
}

export async function runMutation<Arg, Result>(
  initiate: any,
  arg: Arg,
): Promise<Result> {
  const thunk = store.dispatch(initiate(arg)) as any;
  return (await thunk.unwrap()) as Result;
}
